import { ApiUtil as api } from "@/utils/api.util.js";

export class BaseService {
	static URL = process.env.API_URL + process.env.API_VER;
	static achiveRestore(queryParams = {}) {
		return api.post(this.URL + '/bulk/archive/restore', queryParams);
	}
}



// WEBPACK FOOTER //
// ./src/services/base.service.js